import React from 'react'
import { ChevronLeft } from '@mui/icons-material'
import { Stack, IconButton, Typography } from '@mui/material'

import CurrentCredits from '../CurrentCredits'
import { FragmentType, graphql, useFragment } from '@/generated/gql'

const canteenCartTopUpHeaderUserDataFragment = graphql(`
  fragment CanteenCartTopUpHeader_UserDataFragment on User {
    ...CanteenCartCurrentCredits_UserDataFragment
    account {
      userInterfaceSettings {
        hideCCPrices
      }
    }
  }
`)

type Props = {
  onBackClicked: () => void
  userData: FragmentType<typeof canteenCartTopUpHeaderUserDataFragment>
  availableSubsidy: number
}

const Header: React.FC<Props> = ({ onBackClicked, userData: userDataProp, availableSubsidy }) => {
  const userData = useFragment(canteenCartTopUpHeaderUserDataFragment, userDataProp)

  const hidePrices = userData?.account?.userInterfaceSettings.hideCCPrices

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      padding={1}
      paddingRight={2}
    >
      <IconButton onClick={onBackClicked} data-cy="order-modal-close-button">
        <ChevronLeft />
      </IconButton>
      <Typography variant="subtitle2">Top up</Typography>
      {!hidePrices ? (
        <CurrentCredits userData={userData} availableSubsidy={availableSubsidy} />
      ) : null}
    </Stack>
  )
}

export default Header
